import { useRef, useState } from "react";
import { Button, Input } from "reactstrap";

interface Props {

    onSend: (
        message: string
    ) => void;

    onTyping: () => void;

    onStopTyping: () => void;
}

const PrivateMessageInput = ({
    onSend,
    onTyping,
    onStopTyping
}: Props) => {

    const [message, setMessage] =
        useState("");

    const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

   const handleChange = (value: string) => {

    setMessage(value);

    onTyping();

    if (timeout.current) {
        clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {

        onStopTyping();

    }, 1500);
};
    const handleSend = () => {

        if (!message.trim())
            return;

        onSend(message);

        setMessage("");

        onStopTyping();
    };

    return (

        <div
            className="d-flex gap-2 p-3 border-top"
        >

            <Input

                value={message}

                onChange={(e) =>
                    handleChange(
                        e.target.value
                    )
                }

                onKeyDown={(e) => {

                    if (e.key === "Enter") {

                        e.preventDefault();

                        handleSend();

                    }

                }}

                placeholder="Type a message..."

            />

            <Button
                color="primary"
                onClick={handleSend}
            >

                Send

            </Button>

        </div>

    );
};

export default PrivateMessageInput;